import { CoreGraphNode } from "../../../core/graph/CoreGraphNode";
const DEFAULT_DISPLAY_NODE_CONTROLLER_OPTIONS = {
  dependsOnDisplayNode: true
};
export class DisplayNodeController {
  constructor(node, callbacks, options = DEFAULT_DISPLAY_NODE_CONTROLLER_OPTIONS) {
    this.node = node;
    this.options = options;
    this._initialized = false;
    this._display_node = void 0;
    this._graph_node = new CoreGraphNode(node.scene(), "DisplayNodeController");
    this._graph_node.node = node;
    this._on_display_node_remove_callback = callbacks.onDisplayNodeRemove;
    this._on_display_node_set_callback = callbacks.onDisplayNodeSet;
    this._on_display_node_update_callback = callbacks.onDisplayNodeUpdate;
  }
  dispose() {
    this._graph_node.dispose();
  }
  displayNode() {
    return this._display_node;
  }
  initializeNode() {
    if (this._initialized) {
      console.error("display node controller already initialed", this.node);
      return;
    }
    this._initialized = true;
    this.node.lifecycle.onChildAdd((child_node) => {
      var _a, _b;
      if (!this._display_node) {
        (_b = (_a = child_node.flags) == null ? void 0 : _a.display) == null ? void 0 : _b.set(true);
      }
    });
    this.node.lifecycle.onChildRemove((child_node) => {
      var _a, _b, _c;
      if (child_node.graphNodeId() == ((_a = this._display_node) == null ? void 0 : _a.graphNodeId())) {
        const children = this.node.children();
        const last_child = children[children.length - 1];
        if (last_child) {
          (_c = (_b = last_child.flags) == null ? void 0 : _b.display) == null ? void 0 : _c.set(true);
        } else {
          this.setDisplayNode(void 0);
        }
      }
    });
    this._graph_node.dirtyController.addPostDirtyHook("_request_display_node_container", () => {
      if (this._on_display_node_update_callback) {
        this._on_display_node_update_callback();
      }
    });
  }
  async setDisplayNode(new_display_node) {
    if (!this._initialized) {
      console.error("display node controller not initialized", this.node);
    }
    if (this._display_node != new_display_node) {
      const old_display_node = this._display_node;
      if (old_display_node) {
        old_display_node.flags.display.set(false);
        if (this.options.dependsOnDisplayNode) {
          this._graph_node.removeGraphInput(old_display_node);
        }
        if (this._on_display_node_remove_callback) {
          this._on_display_node_remove_callback();
        }
      }
      this._display_node = new_display_node;
      if (this._display_node) {
        if (this.options.dependsOnDisplayNode) {
          this._graph_node.addGraphInput(this._display_node);
        }
        if (this._on_display_node_set_callback) {
          this._on_display_node_set_callback();
        }
      }
    }
  }
}
